import React from 'react'

import FieldRAG_Icon from "../../../../../generic/rag/components/rag-icon"

const debug = false
// const debug = "FieldGoalHealth_InlineValueEmpty"

export default function FieldGoalHealth_InlineValueEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable min-w-125", props.className)} onClick={props.onClick}>
                <FieldRAG_Icon className="fl-ac m-r-5"/>
                <div className="ui5-txt-no-accent-default txt-truncate">
                    Not selected
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )
}